// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"490":"f4fb087e","2005":"04dd9607"}[chunkId] || chunkId) + ".12.3.12rc-31dc1eb.js";
};